import HelpContainer from './HelpContainer';
import {isMobile} from 'Utils/device';
import "./index.scss";
let HelpModuleFn = (isMobile)? null: HelpContainer;

export default HelpModuleFn;